export const styles = {
	topbar:
		'sticky top-0 z-10 flex items-center justify-between gap-md border-b border-subtle bg-white/95 px-xl py-sm backdrop-blur',
	// Two columns from `lg` up: the transcript takes what is left, the rail is
	// fixed at 320px. Below `lg` the rail stacks above — a phone has no room for
	// a rail, and that is the one thing the old single-column layout got right.
	shell: 'mx-auto grid max-w-[1400px] grid-cols-1 gap-xl px-xl py-lg lg:grid-cols-[minmax(0,1fr)_320px]',
	// The chat column caps its own line length; the shell no longer does it for
	// the whole page (that 920px cap is what made the old six-cell metadata grid
	// overlap its own values).
	column: 'flex min-w-0 max-w-[820px] flex-col gap-xl',
	content: 'flex max-w-[920px] flex-col gap-xl px-xl py-lg',
	pageH1: 'text-[26px] font-semibold leading-tight tracking-tight text-default',
	userHeaderAvatar:
		'inline-flex h-[44px] w-[44px] shrink-0 items-center justify-center rounded-full border border-subtle bg-grey-25 text-[14px] font-semibold leading-none text-default',
	sectionH: 'text-[15px] font-semibold leading-tight tracking-tight text-default',
	sectionSub: 'mt-3xs text-[12px] text-subtle',
};
